// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { Suggestion } from './suggestion';

export class ExternalSuggestion extends Suggestion {
}